import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@core/services';

export const publicAuthGuard: CanActivateFn = () => {
	const authService = inject(AuthenticationService);
	const router = inject(Router);

	if (authService.getToken()) {
		router.navigate(['/app/today']);
		return false;
	}

	return true;
};
